// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3LJbX","container":"styles_container__3KzWb","title":"styles_title__mWZdP","wrapper":"styles_wrapper__EQ9Yu","answer":"styles_answer__wTN4y"};